export default __webpack_public_path__ + "static/media/CourageDisney.f205028f.jpg";